import { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // NEW

  const login = (userData) => {
    const expiresAt = Date.now() + 2 * 60 * 60 * 1000; // 2 hours
    const session = { ...userData, expiresAt };
    setUser(session);
    localStorage.setItem('rbmgtUser', JSON.stringify(session));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('rbmgtUser');
    window.location.href = '/login';
  };

  useEffect(() => {
    const stored = localStorage.getItem('rbmgtUser');
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Date.now() < parsed.expiresAt) {
        setUser(parsed);
      } else {
        logout();
      }
    }
    setLoading(false); // NEW
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
